import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET } from "../../services/axios.service";
import { RootState } from "../../app/store";
import { MaterialStockLedgerProps } from "../../types/materialStock";

export interface MaterialStocksState {
  ledger: MaterialStockLedgerProps | null;
  ledgerLoading: boolean;
  ledgerRequestId: string | null;
  // Whether a request has answered since the page opened, so a missing material isn't shown before the first one.
  ledgerLoaded: boolean;
}

const initialState: MaterialStocksState = {
  ledger: null,
  ledgerLoading: false,
  ledgerRequestId: null,
  ledgerLoaded: false,
};

// A material's stock page: its sizes with their totals and its movements, between two optional dates.
export const fetchMaterialStockLedger = createAsyncThunk(
  "fetchMaterialStockLedger",
  async (req: {
    material_id: number;
    fromDate?: string | null;
    toDate?: string | null;
  }) => {
    let response: any;
    await GET(`/v1/admin/material-stocks/ledger`, { ...req })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const materialStocksSlice = createSlice({
  name: "materialStocks",
  initialState,
  reducers: {
    clearMaterialStock: () => initialState,
  },
  extraReducers: (builder) => {
    // Only the latest request counts, so a slow answer asked for earlier can't overwrite it.
    builder.addCase(fetchMaterialStockLedger.pending, (state, action) => {
      state.ledgerLoading = true;
      state.ledgerRequestId = action.meta.requestId;
    });
    builder.addCase(fetchMaterialStockLedger.fulfilled, (state, action: any) => {
      if (action.meta.requestId !== state.ledgerRequestId) return;
      state.ledgerLoading = false;
      state.ledgerLoaded = true;
      state.ledger =
        action.payload?.data?.status === "success"
          ? action.payload.data.data
          : null;
    });
    builder.addCase(fetchMaterialStockLedger.rejected, (state, action) => {
      if (action.meta.requestId !== state.ledgerRequestId) return;
      state.ledgerLoading = false;
      state.ledgerLoaded = true;
    });
  },
});

export const { clearMaterialStock } = materialStocksSlice.actions;

export const getMaterialStockLedger = (state: RootState) =>
  state.materialStocks.ledger;
export const getMaterialStockLedgerLoading = (state: RootState) =>
  state.materialStocks.ledgerLoading;
export const getMaterialStockLedgerLoaded = (state: RootState) =>
  state.materialStocks.ledgerLoaded;

export default materialStocksSlice.reducer;
